import React, { lazy, Suspense, useEffect, useState } from 'react';
import PDFLoading from './PDFLoading';

// pdfjs-dist needs browser globals such as DOMMatrix as soon as it loads, so
// it must never be imported during SSR
const PDF = lazy(() => import('./PDF'));

type PDFProps = React.ComponentProps<typeof PDF>;

const ClientOnlyPDF = (props: PDFProps) => {
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => setIsMounted(true), []);

    if (!isMounted) {
        return <PDFLoading />;
    }
    return (
        <Suspense fallback={<PDFLoading />}>
            <PDF {...props} />
        </Suspense>
    );
};

export default ClientOnlyPDF;
